"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const jsx_runtime_1 = require("react/jsx-runtime");
const SvgActionMenu = props => (0, jsx_runtime_1.jsxs)("svg", {
  "data-name": "action menu",
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  ...props,
  children: [(0, jsx_runtime_1.jsx)("path", {
    "data-name": "Rectangle 472",
    fill: "none",
    d: "M0 0h24v24H0z"
  }), (0, jsx_runtime_1.jsx)("rect", {
    "data-name": "Rectangle 332",
    width: 4,
    height: 4,
    rx: 2,
    transform: "translate(10 3)",
    fill: "#919191"
  }), (0, jsx_runtime_1.jsx)("rect", {
    "data-name": "Rectangle 333",
    width: 4,
    height: 4,
    rx: 2,
    transform: "translate(10 10)",
    fill: "#919191"
  }), (0, jsx_runtime_1.jsx)("rect", {
    "data-name": "Rectangle 334",
    width: 4,
    height: 4,
    rx: 2,
    transform: "translate(10 17)",
    fill: "#919191"
  })]
});
exports.default = SvgActionMenu;